import { useCallback } from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { fireLinkClickedEvent } from '../../utils/analytics/click';
export var ClickButton = /*#__PURE__*/function (ClickButton) {
  ClickButton[ClickButton["Left"] = 0] = "Left";
  ClickButton[ClickButton["Middle"] = 1] = "Middle";
  ClickButton[ClickButton["Right"] = 2] = "Right";
  return ClickButton;
}({});
export var useLinkClicked = function useLinkClicked(handler, predicate) {
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  return useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var event = args[0];
    handler === null || handler === void 0 || handler.apply(null, args);
    if (!predicate || predicate !== null && predicate !== void 0 && predicate(event)) {
      fireLinkClickedEvent(createAnalyticsEvent)(event);
    }
  }, [handler, predicate, createAnalyticsEvent]);
};
var isNotLeftClick = function isNotLeftClick(event) {
  return event.button !== 0;
};
export var useMouseDownEvent = function useMouseDownEvent(onMouseDown) {
  return useLinkClicked(onMouseDown, isNotLeftClick);
};